export default __webpack_public_path__ + "static/media/19.62ae0249.png";